import { ValidationModalSection } from "~/models/navigableValidations/validationSections";
import ReferenceableValidator from "~/models/navigableValidators/referenceableValidator";
import ObjectModelRelation from "../objectModelRelations/objectModelRelation";
import NavigableValidation from "./navigableValidation";

export default class ObjectModelRelationValidation extends NavigableValidation<ObjectModelRelation> {
  validators = [
    new ReferenceableValidator({
      section: ValidationModalSection.Properties
    })
  ]
  
 
}